import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  MarketingFlowStep,
  UpdateMarketingFlowStepPayload
} from "../../marketing.types";

export const requestUpdateMarketingFlowStep = async ({
  flowId,
  stepId,
  data
}: UpdateMarketingFlowStepPayload): Promise<MarketingFlowStep> => {
  return await instance.patch(
    `${ApiRoutesMarketing.Flows}/${flowId}/steps/${stepId}`,
    data
  );
};
